<!--第三方应用-->
<!-- 登录设置 -->
<template>
  <!-- 模板一，不改变面包屑 -->
  <div class="mainArea OnlineUpdate">
    <!-- 主要头部内容 -->
    <div class="mainHeadContent">
      <!-- 面包屑 -->
      <BreadCrumb></BreadCrumb>
    </div>
    <!--主内容区-->
    <div class="mainBodyContent">

      <!-- 添加第三方应用列表 -->
      <div class="addButton">
        <el-button type="primary" @click="openDio">添加</el-button>
        <el-button type="primary" @click="toUpdateLog">更新记录</el-button>
      </div>

      <!-- 第三方应用列表 -->
      <el-table :data="updateList" style="width: 100%" v-loading="tableloading">
        <el-table-column type="index" label="序号"></el-table-column>
        <el-table-column prop="mainboard_type_name" label="主板类型"></el-table-column>
        <el-table-column prop="device_name" label="适用产品"></el-table-column>
        <el-table-column prop="apply_versions" label="适用固件版本"></el-table-column>
        <el-table-column prop="current_versions" label="更新版本号"></el-table-column>
        <el-table-column prop="desc" label="更新内容" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="create_time" label="上传时间"></el-table-column>
        <el-table-column prop="update_count" label="更新次数"></el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button type="text" @click="openUpdate(scope.row.id)">主动更新</el-button>
            <el-button type="text" @click="openDel(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="paging" v-if="total>limits">
        <el-pagination
          @current-change="CurrentChange"
          :current-page.sync="curr"
          :page-size="limits"
          layout="prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>

    <el-dialog title="添加" :visible.sync="addDio" width="600">
      <div class="cont_dio">
        <el-form :model="addform" label-width="120px" ref="form" :rules="rules">
          <el-form-item label="主板类型:" prop="update_type">
            <el-select v-model="addform.update_type" placeholder="请选择主板类型">
              <el-option v-for="(item,index) in typeList" :key="index" :label="item.name" :value="item.key"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="适用产品:">
            <el-select v-model="addform.app_product" placeholder="请选择适用产品">
              <el-option v-for="(item,index) in deviceList" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="适用固件版本:" prop="version">
            <el-input v-model="addform.version" placeholder="请输入适用固件版本"></el-input>
          </el-form-item>
          <el-form-item label="更新版本号:" prop="versionNum">
            <el-input v-model="addform.versionNum" placeholder="请输入版本号"></el-input>
          </el-form-item>
          <el-form-item label="更新文件:" prop="save_url">
            <el-upload
              action="fileUrl"
              class="upload-demo"
              :http-request="uploadFile"
              :limit="1"
              multiple
              :on-exceed="handleExceed"
              :before-upload="beforeAvatarUpload"
              :on-change="handleChange"
              :file-list="fileList">
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
          <el-form-item label="更新内容:">
            <el-input :rows="4" type="textarea" placeholder="选填" v-model="addform.desc"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-button type="primary" @click="submAdd('form')">确认</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <el-dialog title="主动更新" :visible.sync="updateDio" width="600">
      <div class="cont_dio">
        <el-form :model="updateform" label-width="90px" ref="form2" :rules="rules">
          <el-form-item label="更新时间:" prop="time">
            <el-date-picker
              v-model="updateform.time"
              type="datetime"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm"
              placeholder="选择日期时间"
              :default-value="new Date()">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="适用批次:">
            <el-input placeholder="选填" v-model="updateform.batch"></el-input>
          </el-form-item>
          <el-form-item label="设备ID:">
            <div class="device">
              <div class="item" v-for="(item,index) in updateform.deviceList" :key="index">
                <el-input v-model="updateform.deviceList[index]">
                  <template slot="append">
                    <i class="el-icon-circle-close" v-if="index != updateform.deviceList.length-1" @click="delDevice(index)"></i>
                    <i class="el-icon-circle-plus-outline" v-else @click="addDevice"></i>
                  </template>
                </el-input>
              </div>
            </div>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submUpdate('form2')">确定</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <!--删除安装包弹窗-->
    <el-dialog width="600" :visible.sync="delDio">
      <div class="changeStatusWrapper">
        <p class="text">
          是否删除该安装包？
        </p>
        <div slot="footer" class="dialog-footer">
          <el-button @click="delDio = false">取 消</el-button>
          <el-button @click="delUpdate()">删除</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import BreadCrumb from "../../../Layout/BreadCrumb.vue"
  import { showToast, deepCopy,formatFun,updataBreadCrumb } from "../../../../../static/js/utility/utility.js"
  import { systemApi } from "../../../../../static/js/api.js"
  import * as config from "../../../../../static/js/config.js"

  export default {
    name: 'OnlineUpdate',
    components: {
      BreadCrumb
    },
    data() {
      return {
        
        tableloading: false,

        updateList:[],//在线升级

        curr:1,
        limits:10,
        total:0,

        addDio:false,//添加弹窗状态
        typeList:[],//主板类型
        deviceList:[],//设备列表

        addform:{
          update_type:'',//主板类型
          app_product:'',//适用产品
          version:'',//适用固件版本
          versionNum:'',//更新版本号
          save_url:'',//文件存放目录
          down_url:'',//文件下载目录
          desc:'',//更新内容
        },
        fileUrl: config.address+'/UpdataOnline/uploadFile',//文件上传地址
        fileList:[],//文件列表
        rules:{
          update_type:[
            { required: true, message: '请选择主板类型', trigger: 'blur' },
          ],
          version:[
            { required: true, message: '请输入适用固件版本', trigger: 'blur' },
          ],
          versionNum:[
            { required: true, message: '请输入当前版本号', trigger: 'blur' },
          ],
          save_url:[
            { required: true, message: '请上传安装包', trigger: 'blur' },
          ],
          time:[
            { required: true, message: '请选择时间', trigger: 'blur' },
          ],
        },

        updateDio:false,//主动更新弹窗
        updateform:{
          id:'',
          time:'',
          batch:'',
          deviceList:[''],
        },
        
        delDio:false,//删除弹窗
        delId:'',
      }
    },
    created:async function () {
      this.getOnlineUpdate();
    },
    methods: {
      //跳转到更新记录
      toUpdateLog(){
        let that = this;
        let navBarActive = [{function_tab: 'updateLog', function_name: '更新记录'}]
        // 更新面包屑内容
        updataBreadCrumb(3, navBarActive)
        this.$router.push({
          path: '/updateLog',
        })
      },
      //打开删除询问框
      openDel(id){
        this.delId = id
        this.delDio = true;
      },
      //删除安装包
      async delUpdate(){
        let that = this;
        const dataObj = {
          'id': that.delId,
        }
        const res = await systemApi.delUpdate(dataObj)
        if(res.meta.code == 200){
          showToast('删除成功！')
          that.delDio = false
          that.delId = ''
          that.getOnlineUpdate(1);
        }else{
          showToast(res.meta.message)
        }
      },
      submUpdate(formName){
        let that = this
        that.$refs[formName].validate((valid) => {
          if (valid) {
            that.activeUpdate();
          }else {
            return false;
          }
        });
      },
      //主动更新
      async activeUpdate(){
        let that = this;
        const arr = this.updateform.deviceList

        for(var i in arr){  
          if(arr[i] == " " || arr[i] == null || typeof(arr[i]) == "undefined") {  
            arr.splice(i,1);  
            i= i-1;
          }
        }
        var deviceArr = arr.filter(item=>item)
        console.log('11',deviceArr)
        const dataObj = {
          'package_id': that.updateform.id,//安装包id
          'batch': that.updateform.batch,//适用批次
          'update_time': that.updateform.time,//更新时间
          'device_list': deviceArr,//设备id列表
        }
        if(that.updateform.batch == '' && arr == ''){
          showToast('适用批次与设备必须填写一项~')
          return
        }
        const res = await systemApi.addDevicePackageQeueu(dataObj)
        if(res.meta.code == 200){
          showToast('更新成功！')
          that.updateDio = false
          that.updateform={
            id:'',
            time:'',
            batch:'',
            deviceList:[''],
          }
        }else{
          showToast(res.meta.message)
        }
      },
      //删除设备id
      delDevice(index){
        this.updateform.deviceList.splice(index,1);
      },
      //添加设备id
      addDevice(){
        this.updateform.deviceList.push('');
      },
      //打开主动更新
      openUpdate(id){
        let that = this;
        let myDate = new Date();
        this.updateform.time = formatFun(myDate, "yyyy-MM-dd HH:mm")
        this.updateform.id = id
        this.updateDio = true
      },
      
      //添加安装包
      submAdd(formName){
        let that = this
        that.$refs[formName].validate((valid) => {
          if (valid) {
            that.addUpload();
          }else {
            return false;
          }
        });
      },
      async addUpload(){
        let that = this;
        const dataObj = {
          'mainboard_type': that.addform.update_type,//主板类型
          'device_id': that.addform.app_product,//适用产品
          'apply_versions': that.addform.version,//适用固件版本
          'current_versions': that.addform.versionNum,//更新版本号
          'file_path': that.addform.save_url,//文件存放目录
          'down_path': that.addform.down_url,//文件下载目录
          'desc': that.addform.desc,//更新内容
        }
        const res = await systemApi.addDevicePackage(dataObj)
        if(res.meta.code == 200){
          showToast('添加成功！')
          that.addDio = false
          that.getOnlineUpdate(1);
          that.addform = {
            update_type:'',//主板类型
            app_product:'',//适用产品
            version:'',//适用固件版本
            versionNum:'',//更新版本号
            save_url:'',//文件存放目录
            down_url:'',//文件下载目录
            desc:'',//更新内容
          }
        }else{
          showToast(res.meta.message)
        }
      },
      //打开添加弹窗
      openDio(){
        this.getDeviceParam()
        this.addDio = true;
      },
      //获取在线升级列表
      async getOnlineUpdate(curr,limits){
        let that = this;
        const dataObj = {
          'page': curr ? curr : that.curr,
          'perPage': limits ? limits : that.limits,
        }
        this.tableloading = true;
        const res = await systemApi.selectDevicePackage(dataObj)
        if(res.meta.code == 200) {
          that.updateList = res.data.list
          that.total = parseInt(res.data.count)
          that.tableloading = false;
        }else{
          this.tableloading = false;
          showToast(res.meta.message)
        }
      },
      //点击当前页调用接口
      CurrentChange(val){
        this.curr = val
        this.getOnlineUpdate(val)
      },

      //获取主板类型和设备类型
      async getDeviceParam(){
        let that = this;
        const res = await systemApi.getDeviceParam()
        if(res.meta.code == 200) {
          that.typeList = res.data.mainboard_types
          that.deviceList = res.data.devices
        }else{
          showToast(res.meta.message)
        }
      },
      //上传文件校验
      beforeAvatarUpload(file) {
        const isLt10M = file.size / 1024 < 10000;
        if (!isLt10M) {
          showToast('上传文件大小不能超过 10MB!')
          // this.$message.error('上传文件大小不能超过 100KB!');
        }
        return isLt10M;
      },
      //上传文件
      async uploadFile(param){
        let that = this
        let formData = new FormData()
        formData.append('file', param.file)
        // formData.append('type', 'binary')
        let res = await systemApi.uploadFile(formData)
        if (res.meta.code === 200) {
          that.addform.save_url = res.data.file_path
          that.addform.down_url = res.data.down_path
        } else {
          showToast(res.meta.message)
        }
      },
      handleChange(file, fileList) {
        this.fileList = fileList.slice(-1);
      },
      handleExceed(files, fileList) {
        showToast('只能上传1个文件！')
        // this.$message.warning('只能上传1个文件！')
      },
    },
    watch: {
      
    }
  }
</script>

<style lang="scss">
.OnlineUpdate{
  .mainBodyContent{
    min-height: calc(100vh - 194px);
  }
  .cont_dio{
    .device{
      display: flex;
      justify-content:space-between;
      flex-wrap: wrap;
      .item{
        width: 48%;
        margin-bottom: 10px;
        .el-input__inner{
          border-right: none;
          &:focus{
            border-color: #DCDFE6;
          }
        }
        .el-input-group__append{
          font-size: 20px;
          padding: 0 10px;
          background: #fff;
          border-left: none;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Page/System/OnlineUpdate/OnlineUpdate.vue